import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CarTrafficRoutingModule } from '@ruby/modules/car-traffic/car-traffic-routing.module';
import { CarTrafficContainer } from '@ruby/modules/car-traffic/containers/car-traffic.container';
import * as fromTrafficHistory from '@ruby/modules/car-traffic/store';

@NgModule({
  declarations: [CarTrafficContainer],
  imports: [
    CommonModule,
    EffectsModule.forFeature(fromTrafficHistory.effects),
    CarTrafficRoutingModule,
    StoreModule.forFeature(fromTrafficHistory.featureKey, fromTrafficHistory.reducer)
  ],
  exports: [CarTrafficContainer]
})
export class CarTrafficModule {}
